import styled, { css } from 'styled-components'
import Background from '../../assets/pattern_form.png'
import AlertError from '../../assets/alert_error.svg'

const FormStyle = styled.section`
  width: 100%;
  padding: 50px 0 220px;
  background: url(${Background}) bottom center no-repeat;
  position: relative;

  > div {
    flex-direction: column;

    h2 {
      font-size: 30px;
      line-height: 0.7;
      font-family: 'DomaineSansText-BoldItalic';

      .title {
        display: block;
        color: #234757;
        font-size: 14px;
        text-align: left;
        letter-spacing: 0.42px;
        font-family: 'DomaineSansText-Regular';
      }
      .pos-title {
        color: #107e78;
        font-size: 58px;
        font-family: 'FeltThatW01-Regular';
      }
    }

    h3 {
      color: #009f67;
      font-size: 22px;
      font-weight: bold;
      line-height: 1.33;
      text-align: center;
      margin-bottom: 40px;
      font-family: 'DomaineSansText-BoldItalic';
    }

    p {
      color: #505050;
      font-size: 16px;
      text-align: center;
      margin-bottom: 50px;
      font-family: 'DomaineSansText-Regular';
    }
  }

  .overlay {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100vh;
    background-color: rgba(2, 0, 0, 0.8);
    z-index: 1;
  }

  @media (max-width: 800px) {
    padding: 25px 25px 220px 25px;
  }
`

const Step = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;

  i {
    position: relative;
    width: 100px;
    height: 2px;
    background: #dde6eb;

    &:after {
      display: block;
      content: '';
      width: 0px;
      height: 2px;
      background: #dde6eb;
      transition: width 0.5s ease-in-out;
    }

    &.active {
      &:after {
        background: #007e78;
        width: 100%;
        transition: width 0.5s ease-in-out;
      }
    }
  }
`

const StepItem = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  color: #dde6eb;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.8;
  justify-content: center;
  font-family: 'DomaineSansText-BlackItalic';
  border: 2px solid #dde6eb;
  border-radius: 100%;
  transition: all 0.5s ease-in-out;

  &.active {
    background: #007e78;
    border-color: #007e78;
    transition-delay: 0.5s;
  }
`

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  width: 930px;
  margin: 0 auto;
  justify-content: space-around;

  .acceptTerm {
    span {
      margin-left: 5px;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .hidden {
    display: none;
  }

  @media (max-width: 800px) {
    width: 100%;
    flex-direction: column;
  }
`

const buttonStyle = css`
  font-size: 15px;
  line-height: 1.1;
  padding: 13px 40px;
  margin: 50px auto 0px;
  text-transform: uppercase;
  border: 1px solid #007e78;
  border-radius: 5px;
`

const Submit = styled.button`
  ${buttonStyle}
  color: ${(props) => (props.primary ? '#fff' : '#007e78')};
  background: ${(props) => (props.primary ? '#007e78' : '#ecf1f4')};
  border-color: ${(props) => (props.primary ? '#007e78' : '#ecf1f4')};
  cursor: ${(props) => (props.primary ? 'pointer' : 'normal')};
`

const Button = styled.div`
  ${buttonStyle}
  color: #007e78;
  cursor: pointer;
  background: #fff;
`

const FormColumn = styled.div`
  display: flex;
  width: 47%;
  flex-direction: column;

  &.FormColumn--full {
    width: 90%;
  }

  @media (max-width: 800px) {
    width: 100%;
  }

  input,
  select {
    height: 41px;
    color: #234757;
    font-size: 28px;
    padding: 0 12px;
    line-height: normal;
    background-color: transparent;
    border-radius: 0px;
    border-color: transparent;
    border-bottom: 1px solid #027a75;
    font-family: 'DomaineSansText-Regular';
  }

  .inputCelular {
    display: flex;
    border-bottom: 1px solid #027a75;

    input {
      border: none;

      &:focus {
        outline-width: 0 !important;
        outline: none !important;
      }
    }

    &:before {
      content: '+57';
      display: block;
      font-family: DomaineSansText-Regular;
      font-size: 28px;
      color: #234757;
      width: 50px;
      height: auto;
    }
  }

  label {
    color: #8a9ba5;
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
    font-family: 'DomaineSansText-Regular';
    margin-top: 40px;

    a {
      color: #027a75;
      text-decoration: underline;
    }
  }
`

const FormRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;

  &.FormRow--mobile {
    flex-direction: column;
  }

  &.right {
    align-items: start;
    flex-direction: column;
    justify-content: right;
    margin-top: 15px;

    input,
    label {
      margin: 0;
    }

    label {
      display: flex;
      align-items: center;
    }

    input {
      margin-right: 10px;
    }
  }
`

const Danger = styled.p`
  display: flex;
  width: 100%;
  color: #611a15;
  margin: 0 !important;
  background: #fdecea;
  font-family: 'DomaineSansText-Regular';
  justify-content: space-around;

  &:before {
    content: url(${AlertError});
    width: 14px;
    height: 14px;
    line-height: 1.5;
    margin: 0 6px;
    left: 5px;
  }
`

const SuccessContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  top: 0px;

  div > {
    h4 {
      color: #107e78;
      font-size: 80px;
      font-family: 'FeltThatW01-Regular';
    }
    h5 {
      margin: 24px 0;
      font-size: 20px;
      font-weight: 600;
      font-family: 'Poppins', sans-serif !important;
    }
    p {
      width: 100%;
      font-size: 16px;
      margin-bottom: 0px;
      font-weight: 400;
      color: #000000;
      font-family: 'Poppins', sans-serif !important;
    }
  }
`

const Success = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: white;
  width: 593px;
  max-width: 99%;
  border-radius: 5px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
  padding: 40px 24px 65px;
  position: relative;
`

const CloseSuccess = styled.div`
  position: absolute;
  top: 17px;
  right: 17px;
  cursor: pointer;
`

export {
  FormStyle,
  Step,
  StepItem,
  Form,
  FormColumn,
  FormRow,
  Danger,
  Success,
  SuccessContainer,
  Button,
  Submit,
  CloseSuccess
}
